import { styled } from '@mui/material/styles';
import { Grid, Typography } from '@mui/material';
import CustomButton from '../../../../components/UI/CustomButton/CustomButton';

export const ReviewTableSkeletonGrid = styled(Grid)(() => ({
  flex: 1,
  padding: '2%',
  overflowY: 'auto',
}));

export const ReviewTableContainer = styled(Grid)(() => ({
  position: 'absolute',
  height: '680px',
  background: 'white',
  width: '100%',
  zIndex: 10,
  border: '1px solid red',
  marginTop: '10px',
  borderRadius: '7.01px',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: '0 3px .625pc 0 rgb(0 0 0 / 6%) !important',
}));

export const ColumnContainer = styled(Grid)(() => ({
  whiteSpace: 'nowrap',
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
}));

export const ReviewTableHeading = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: '14.52px',
  lineHeight: '17.71px',
}));

export const ConfirmationSection = styled(Grid)(() => ({
  position: 'relative',
  marginTop: 'auto',
  padding: '10px',
  display: 'flex',
  justifyContent: 'flex-end',
}));

export const BackBtnToInputScreen = styled(CustomButton)(() => ({
  background: 'white',
  color: 'black',
  height: '41.56px',
  width: '127.52px',
  fontWeight: 600,
  fontSize: '14.07px',
  lineHeight: '17.16px',
  '&:hover': {
    background: 'white !important',
    color: 'black !important',
  },
}));

export const RunBtnToOutputScreen = styled(CustomButton)(() => ({
  background: '#DF2020',
  color: 'white',
  height: '41.51px',
  width: '140.39px',
  fontWeight: 600,
  fontSize: '14.07px',
  lineHeight: '17.16px',
  marginLeft: '15px',
}));
